import * as PropTypes from 'prop-types'

const JobHistoricalShape = PropTypes.shape({

})

export { JobHistoricalShape }
